import { render, staticRenderFns } from "./ArticlesSlider.vue?vue&type=template&id=f36a8d14&scoped=true&"
import script from "./ArticlesSlider.vue?vue&type=script&lang=js&"
export * from "./ArticlesSlider.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSlider.vue?vue&type=style&index=0&id=f36a8d14&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36a8d14",
  null
  
)

export default component.exports